import { _ as _defineProperty } from '../defineProperty-2d1aa32d.js';
import { Suspense, lazy } from 'react';
import { u as useCheckoutModalContext } from '../CheckoutModalContext-fa8f6d02.js';
import { jsx } from 'react/jsx-runtime';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LazyCheckoutModal = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: 'CheckoutModal' */'../CheckoutModal-f0b15ab6.js');
});
var index = (function (props) {
  var _useCheckoutModalCont = useCheckoutModalContext(),
    isOpen = _useCheckoutModalCont.isOpen;
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/jsx(LazyCheckoutModal, _objectSpread({}, props))
  });
});

export { index as default };
//# sourceMappingURL=index.js.map
